exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-area[data-v-7f780bd7] {\n  position: relative;\n  /*margin: auto*/\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
